import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL + '/products';
const setTokenAllHeaders = async () => {
    const token = localStorage.getItem("adminToken");
    axios.defaults.headers.common["Authorization"] = token;
}

const getAllProducts = async ({ limit = 15, page = 0, status = null, sortModel = [], filterModel = {}, search: searchText = null }) => {
    try {
        await setTokenAllHeaders();
        let sendStatus = status;
        if (sendStatus === 0) {
            sendStatus = null;
        }
        const quickFilterSearch = Array.isArray(filterModel?.quickFilterValues)
            ? filterModel.quickFilterValues.join(" ").trim()
            : "";
        const search = String(searchText || quickFilterSearch || "").trim() || null;

        const response = await axios.get(`${BASE_URL}/get`, {
            params: {
                limit,
                page,
                status: sendStatus,
                search,
                sort: sortModel,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};
const getProductsData = async (productId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/detail`, {
            params: {
                productId,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};

const checkSlugExists = async (slug, productId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/checkslug`, {
            params: {
                slug,
                productId,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};
const updateProducts = async (formData) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}/update`, { ...formData });
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};
const uploadPosProductExcel = async (formData) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}/import-products`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',  // Set this header to handle file uploads
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};
const updateProductsItems = async (formData) => {
    try {
        // console.log(formData, 'formData');  // You can remove this after debugging
        await setTokenAllHeaders();

        // Use axios to send the form data directly
        const response = await axios.post(`${BASE_URL}/item/update`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',  // Set this header to handle file uploads
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error saving items:', error);
        throw error;
    }
};

const getProductUnits = async (limit = 10, page = 0, params = null) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/units`, {
            params: {
                limit,
                page,
                ...params
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching all units:', error);
        throw error;
    }
};

const getAllProductItems = async ({ limit = 15, page = 0, status = null, sortModel = [], filterModel = [] }) => {
    try {
        await setTokenAllHeaders();
        let sendStatus = status;
        if (sendStatus === 0) {
            sendStatus = null;
        }
        let search = null;
        if (filterModel['quickFilterValues']) {
            search = filterModel['quickFilterValues'].join(" ").trim() || null;
        }

        const response = await axios.get(`${BASE_URL}/items`, {
            params: {
                limit,
                page,
                sendStatus,
                search,
                sort: sortModel,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};

const updateProductStatus = async (params, type = 'product') => {
    try {
        await setTokenAllHeaders();
        const dt = { ...params, tableType: type };
        const response = await axios.post(`${BASE_URL}/status/`, dt);
        return response.data;
    } catch (error) {
        console.error(`Error updating product status:`, error);
        throw error;
    }
};

const getProductStockData = async (productId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/items/stock`, {
            params: {
                productId,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};

const updateInventory = async (params) => {
    try {
        await setTokenAllHeaders();
        const dt = { ...params };
        // console.log(dt,'DRT');
        const response = await axios.post(`${BASE_URL}/inventory/update`, dt);
        return response.data;
    } catch (error) {
        console.error(`Error updating product inventory:`, error);
        throw error;
    }
};

const checkRefCode = async (refCode, itemId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/checkrefcode`, {
            params: { refCode, itemId }, // when editing, pass current itemId to exclude it
        });
        return response.data; // -> { success, message, data: { exists: boolean } }
    } catch (error) {
        console.error('Error checking ref code:', error);
        throw error;
    }
};

const fetchPosReferenceItems = async (params = {}) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(
            `${BASE_URL}/pos-reference-items`,
            { params }
        );
        return response.data; // { status, message, data: { items: [...] } }
    } catch (error) {
        console.error("Error fetching POS reference items:", error);
        throw error;
    }
};

const syncPosReferenceItems = async (payload) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(
            `${BASE_URL}/pos-reference-items/sync`,
            payload
        ); // payload = { items: [...] }
        return response.data; // { status, message, data: { ...summary } }
    } catch (error) {
        console.error("Error syncing POS reference items:", error);
        throw error;
    }
};

const getProductItemById = async (productItemId) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.get(`${BASE_URL}/items/${productItemId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching product item by id:", error);
        throw error;
    }
};

const productAPI = {
    getAllProducts,
    checkSlugExists,
    updateProducts,
    getProductUnits,
    getProductsData,
    updateProductsItems,
    getAllProductItems,
    updateProductStatus,
    getProductStockData,
    updateInventory,
    checkRefCode,
    uploadPosProductExcel,
    fetchPosReferenceItems,
    syncPosReferenceItems,
    getProductItemById
};
export default productAPI;
